export default "__VITE_ASSET__11cdf8c7__"